module.exports = __webpack_public_path__ + "img/banner-5.1eff3b73.png";